import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ETrademarkImportColumn, ITrademarkImportLine } from 'src/app/pages/trademarks/trademark-declare/trademark-declare-import/trademark-declare-import.component';

@Component({
  selector: 'app-trademarks-import-overview-list-dialog',
  templateUrl: './trademarks-import-overview-list-dialog.component.html',
  styleUrls: ['./trademarks-import-overview-list-dialog.component.scss']
})
export class TrademarksImportOverviewListDialogComponent {
  title: string = '';
  text: string = '';
  trademarks: ITrademarkImportLine[] = [];
  displayedColumns: string[] = ['line', ETrademarkImportColumn.APPLICATION_NUMBER, ETrademarkImportColumn.REGISTRATION_NUMBER, ETrademarkImportColumn.COUNTRY_OF_DESIGNATION, ETrademarkImportColumn.BRAND_TYPE, ETrademarkImportColumn.OFFICE];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<TrademarksImportOverviewListDialogComponent>
  ) {

  }

  ngOnInit(): void {
    this.title = this.data.title;
    this.text = this.data.text;
    this.trademarks = this.data.trademarks;
  }

  onCancel() {
    this.dialogRef.close()
  }
}
